module.exports = __webpack_public_path__ + "d973252229ee6d5b1a80538ca7c4dc48.pdf";